import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from "react-redux"
import { store } from "./redux/store"
import { ThemeProvider } from './context';
import { ModalProvider } from './contexts/modal.context';
import { ScreenProvider } from './contexts/screen.provider';
import { initAppInsights } from "./telemetry/appInsights";

initAppInsights();

const root: ReactDOM.Root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <ThemeProvider>
      <ScreenProvider>
        <ModalProvider>
          <App/>
        </ModalProvider>
      </ScreenProvider>
    </ThemeProvider>
  </Provider>
);

// --------------------
// Service Worker Registration
// --------------------
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("Service Worker registered:", registration);
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  });
}